import type { ReactNode } from 'react';

import { addFormatter } from 'atoms/formatted-content/formatter';

addFormatter('line-breaks', {
	selector: /([\n\r]{1})/g,
	defaultIgnored: false,
	decorator: (guid: string): ReactNode => <br key={guid} />,
});
